import Vue from 'vue'

export default Vue.extend({
  name: 'Plan',
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClickPlan () {
      this.$router.push({ path: `/contents/${this.plan.content_id}` })
    }
  }
})
